export const AUTHENTICATION_SERVICE = {
  PHONE_AUTHENTICATION: 100,
  LDAP_INTEGRATION: 24,
  BASIC_AUTHENTICATION_INTEGRATION: 41,
  AZURE_AD_INTEGRATION: 32,
  GOOGLE_INTEGRATION: 55,
  PASSKEY_AUTHENTICATION: 72
}